import { useEffect, useState } from 'react';
import Iframe from 'react-iframe';
import { Status } from '../../constants';
import MessageStatus from '../../components/message-status';
import { redirecTo } from '../../utils';
import Loading from 'components/common/loading';
import {
  selectLoading,
  selectError,
  selectErrorInfo,
  selectStatus,
  selectPaymentData,
  getPaymentInfoAsync,
  saveDeviceId,
  selectConfirmPayment,
} from '../../features/payment/payment-slice';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { useTranslation } from 'react-i18next';
import Header from 'components/header';
import Footer from 'components/footer';
import CheckoutContent from 'components/checkout-content';
import ResultContent from 'components/result-content';
import Dialog from 'components/common/dialog';
import SelectCountry from 'components/select-country';
import { Button } from 'components/common/button';

const Checkout = () => {
  const { t } = useTranslation();
  const loading = useAppSelector(selectLoading);
  const error = useAppSelector(selectError);
  const errorInfo = useAppSelector(selectErrorInfo);
  const status = useAppSelector(selectStatus);
  const paymentData = useAppSelector(selectPaymentData);
  const confirmPayment = useAppSelector(selectConfirmPayment);
  const dispatch = useAppDispatch();

  const [backConfirm, setBackConfirm] = useState(false);

  useEffect(() => {
    window.dlocalCollector
      ?.create({
        ENV: process.env.REACT_APP_ENV === 'production' ? 'production' : 'sandbox',
        apiKey: process.env.REACT_APP_DLOCAL_KEY || '',
      })
      .then((deviceId: string) => dispatch(saveDeviceId(deviceId)));
  }, []);

  useEffect(() => {
    if (Status.INIT === status) {
      dispatch(getPaymentInfoAsync());
    }
  }, []);

  if (paymentData && paymentData.url && !paymentData.iframe) {
    redirecTo(paymentData.url);
    return <Loading fullScreem noBackground />;
  }

  return (
    <div>
      {loading && <Loading fullScreem noBackground />}
      {!loading && error && <MessageStatus errorInfo={errorInfo} />}
      {!loading && !error && Status.SUCCESS === status && paymentData && (
        <>
          <Header
            logoUrl={paymentData.merchantLogo}
            onClickBack={paymentData.backUrl ? () => setBackConfirm(true) : undefined}
          />
          {!paymentData?.countrySelected && paymentData?.availableCountries && paymentData.availableCountries?.length > 0 ? (
            <SelectCountry />
          ) : (
            <>
              {confirmPayment.success || confirmPayment.noRetryError ? <ResultContent /> : <CheckoutContent />}
              <Footer success={!!(confirmPayment.success || confirmPayment.noRetryError)} />
            </>
          )}
        </>
      )}
      {paymentData?.url && paymentData?.iframe && (
        <Dialog fullScreen unpaddingContent>
          <Iframe url={paymentData.url} className="iframe" width="100%" height="100%" position="absolute" frameBorder={0} />
        </Dialog>
      )}
      {confirmPayment?.success?.url && confirmPayment?.success?.iframe && (
        <Dialog fullScreen unpaddingContent>
          <Iframe
            url={confirmPayment.success.url}
            className="iframe"
            width="100%"
            height="100%"
            position="absolute"
            frameBorder={0}
          />
        </Dialog>
      )}
      {backConfirm && (
        <Dialog
          dividers={false}
          title={t('paymentMethod.backConfirm.title')}
          handleClose={() => setBackConfirm(false)}
          footer={
            <>
              <Button onClick={() => setBackConfirm(false)}>{t('common.cancel')}</Button>
              <Button
                onClick={() => {
                  setBackConfirm(false);
                  paymentData?.backUrl && redirecTo(paymentData.backUrl);
                }}
              >
                {t('common.yes')}
              </Button>
            </>
          }
        >
          <div className="back-confirm-body">{t('paymentMethod.backConfirm.body')}</div>
        </Dialog>
      )}
    </div>
  );
};

export default Checkout;
